document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('.live-search-form-field');
    const searchLayout = document.querySelector('.custom-search-layout');
    const popularArea = document.querySelector('.custom-search-popular');
    const resultsArea = document.querySelector('.custom-search-results-area');
    const seeAllLink = document.querySelector('.search-see-all-link');

    // Initialize Splide for Popular Categories

    const categorySlider = document.getElementById('popular-categories-slider');

    if (categorySlider && typeof Splide !== 'undefined') {
        new Splide('#popular-categories-slider', {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '20px',
            pagination: false,
            arrows: true,
            breakpoints: {
                1024: {
                    perPage: 2,
                },
                767: {
                    destroy: true
                }
            }
        }).mount();
    }

    // Handle Search Input Toggle Logic

    function handleSearchInput() {
        if (!searchInput || !searchLayout) return;
        const query = searchInput.value.trim();
        if (seeAllLink) {
            if (query.length > 0) {
                seeAllLink.href = '/search?q=' + encodeURIComponent(query);
            } else {
                seeAllLink.href = '/search';
            }
        }

        if (query.length > 0) {
            searchLayout.classList.add('has-query');
        } else {
            searchLayout.classList.remove('has-query');
        }
    }

    // Initial check in case of pre-filled value

    handleSearchInput();

    if (searchInput) {
        searchInput.addEventListener('input', handleSearchInput);
    }

    // Handle No Results visibility for See All Link
    if (resultsArea && seeAllLink) {
        const liveSearchResults = resultsArea.querySelector('[data-live-search-results]');
        if (liveSearchResults) {
            const observer = new MutationObserver(function() {
                const noResultsElem = liveSearchResults.querySelector('[data-live-search-no-products]');
                if (noResultsElem) {
                    seeAllLink.style.display = 'none';
                } else {
                    seeAllLink.style.display = '';
                }
            });
            observer.observe(liveSearchResults, { childList: true, subtree: true });
        }
    }

    // Intercept Popular Search Clicks

    const popularLinks = document.querySelectorAll('.popular-links-list a');
    popularLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            if (searchInput) {
                searchInput.value = this.textContent.trim();
                // Trigger handleSearchInput for our UI
                handleSearchInput();

                // Trigger keyup for Empire.js live search bind 
                searchInput.dispatchEvent(new Event('keyup', { bubbles: true }));
                searchInput.focus();
            }
        });
    });
});
